module.exports = __webpack_public_path__ + "static/media/back.283f6045.svg";